export const BOX_SIZES = { BIG: 16, MEDIUM: 14, SMALL: 12 };

export const BOXES = [BOX_SIZES.SMALL, BOX_SIZES.MEDIUM, BOX_SIZES.BIG];
